import { CommanderThunkAction, WithCompanyId, WithOwnerId } from '@mews-commander/types';
import { compactArray } from '@mews/fp';
import { fetchAccountsByIds } from './accounts';

export const fetchSendEmailDialogData =
    ({ ownerId, companyId }: WithOwnerId & WithCompanyId): CommanderThunkAction =>
    async (dispatch) =>
        dispatch(fetchAccountsByIds({ accountIds: compactArray([ownerId, companyId]) }));
